import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import type { PaywallCheckoutPreview } from "@circle-react/types";

import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { CheckoutPreviewEntryProps } from "../../../components/PreviewEntry";
import type { ComponentLineProps } from "../../FirstPaymentPreview/types";

const buildOptions = (
  preview: PaywallCheckoutPreview,
): Partial<CheckoutPreviewEntryProps> => ({
  label: t(
    [
      "paywall_checkout.future_payments.remaining_payments",
      preview.paywall_price.interval_type,
    ],
    {
      count: preview.remaining_payments?.installments_preview.length,
    },
  ),
  labelWeight: "semibold",
  valueWeight: "semibold",
  value: formatPaywallCurrencyAmount(
    preview.currency,
    preview?.remaining_payments?.total_amount_due || 0,
  ),
});

export const TitleLine = ({ preview }: Pick<ComponentLineProps, "preview">) => {
  const options = buildOptions(preview);
  return <DefaultFullPreview.PreviewEntry label="" {...options} />;
};
